module.exports = __webpack_public_path__ + "img/nespresso_banner_mobile.6f0c6f3.png";